<!-- @format -->

<items-page>
  <style>
    .page_title p {
      word-break: break-all;
    }
  </style>

  <div class="wrapper page">
    <section class="page_wrap">
      <div class="page_inner">
        <nav class="breadcrumb">
          <ul class="breadcrumb_list">
            <li class="breadcrumb_list-item">
              <a href="{ routes.makePath('accept-page') }">解析結果一覧</a>
            </li>
            <li class="breadcrumb_list-item">解析結果URL一覧</li>
          </ul>
          <!--/.breadcrumb_list-->
        </nav>
        <!--/.breadcrumb-->

        <h1 class="main_title page">解析結果URL一覧</h1>

        <div class="sub_title-container">
          <h2 class="sub_title">解析対象</h2>
          <dl class="history-info" each="{ data in [state.analytic] }">
            <dt class="history-info_heading">解析日時：</dt>
            <dd class="history-info_number">{ data.created }</dd>
            <dt class="history-info_heading">文字数：</dt>
            <dd class="history-info_number">{ data.length }</dd>
            <dt class="history-info_heading">消費カウント：</dt>
            <dd class="history-info_number">{ data.ticket }</dd>
            <dt class="history-info_heading">履歴ID：</dt>
            <dd class="history-info_number">{ data.id }</dd>
            <template if="{ data.status!=1 }">
              <dt class="history-info_heading">最高一致文字数：</dt>
              <dd class="history-info_number">
                <span class="emphasis">{ data.duplication_length }</span>
              </dd>
              <dt class="history-info_heading">最大一致率：</dt>
              <dd class="history-info_number">
                <emphasized-value
                  ratio="{ data.duplication_ratio }"
                ></emphasized-value>
              </dd>
              <dt class="history-info_heading">総合類似度：</dt>
              <dd class="history-info_number">
                <emphasized-value
                  if="{ state.analytic.type == 1 }"
                  value="-"
                ></emphasized-value>
                <emphasized-value
                  if="{ state.analytic.type == 2 }"
                  ratio="{ data.total }"
                ></emphasized-value>
              </dd>
            </template>
          </dl>
        </div>
        <!--/.sub_title-container-->
        <div class="analysis_txt-container">
          <div class="analysis_txt-inner">
            <p class="analysis_txt { state.isShow ? 'is-show' : '' }">
              { state.analytic ? state.analytic.summary : '' }
            </p>
            <div class="view_more-box js-view">
              <a
                class="view_more { state.isShow ? 'close' : '' }"
                onclick="{ onToggleShow }"
              ></a>
            </div>
          </div>
          <!--/.analysis_txt-inner-->
        </div>
        <!--/.analysis_txt-container-->

        <section class="result_list-wrap">
          <div class="result_tab-menu">
            <ul class="result_tab-menu-list">
              <li
                class="result_tab-menu-list-item { state.tab == 'duplication' ? 'is-active' : '' }"
              >
                <a class="js-tab" onclick="{ e => onChangeTab('duplication') }">
                  文字列の重複度
                </a>
              </li>
              <li
                if="{ state.analytic.type == 2 }"
                class="result_tab-menu-list-item { state.tab == 'similarity' ? 'is-active' : '' }"
              >
                <a class="js-tab" onclick="{ e => onChangeTab('similarity') }">
                  類似チェック
                </a>
              </li>
            </ul>
          </div>
          <!--/.result_tab-menu-->

          <div class="tab_contents active" if="{ state.tab == 'duplication' }">
            <div class="checkbox_wrap">
              <input
                type="checkbox"
                name="csv-check_all-duplication"
                value="csv-check_all-duplication"
                id="csv-check_all-duplication"
                class="checkbox-input"
                onchange="{ onCheckAll }"
              />
              <label
                for="csv-check_all-duplication"
                class="checkbox-parts"
              ></label>
              <p class="history-list_check_csv-duplication">
                <a
                  class="dl_csv { state.checked ? 'checked' : '' }"
                  onclick="{ onDownload }"
                >
                  選択中の解析結果をCSVでダウンロード
                </a>
              </p>
            </div>
            <!--/.checkbox_wrap-->
            <div class="sort_menu-container">
              <div class="sort-menu">
                <label for="sort" class="sort-menu-title">並び替え</label>
                <select
                  name="sort"
                  class="select-result"
                  onchange="{ e => onSort(e.target.value) }"
                >
                  <option value="length">最高一致文字数</option>
                  <option value="duplication_ratio">一致率</option>
                </select>
              </div>
              <!--/.sort-menu-->
            </div>
            <!--/.sort_menu-container-->

            <div class="result-table-wrap">
              <table class="result-table">
                <thead class="result-heading">
                  <tr>
                    <th class="csv"></th>
                    <th class="txt_count">最高一致文字数</th>
                    <th class="txt_percent">一致率</th>
                    <th class="txt_locate">重複箇所</th>
                    <th class="page_title">ページタイトル</th>
                    <th class="page_url">URL</th>
                  </tr>
                </thead>
                <tbody class="result-contents">
                  <tr each="{ (item, i) in state.items }">
                    <td class="csv">
                      <div class="history-list_check-container">
                        <p class="history-list_check-duplication">
                          <input
                            type="checkbox"
                            name="csv-check-duplication"
                            id="csv-check-dupulication-{ i }"
                            class="checkbox-input"
                            checked="{ item.checked }"
                            onchange="{ e => onCheck(e, i) }"
                          />
                          <label
                            for="csv-check-dupulication-{ i }"
                            class="checkbox-parts history-list_check"
                          ></label>
                        </p>
                      </div>
                      <!--/.history-list_check-container-->
                    </td>
                    <td class="txt_count">
                      <div class="level-{ getLevel(item.length, 'length') }">
                        <emphasized-value
                          value="{ item.length }"
                        ></emphasized-value>
                      </div>
                    </td>
                    <td class="txt_percent">
                      <div
                        class="level-{ getLevel(item.duplication_ratio*100, 'ratio') }"
                      >
                        <emphasized-value
                          ratio="{item.duplication_ratio}"
                          fixed="1"
                        ></emphasized-value>
                      </div>
                    </td>
                    <td class="txt_locate">
                      <div class="locate level-3">
                        <emphasized-value
                          value="{ item.duplication_count }"
                          unit="箇所"
                        ></emphasized-value>
                      </div>
                    </td>
                    <td class="page_title">
                      <p>{ item.title }</p>
                    </td>
                    <td class="page_url">
                      <p>
                        <a
                          href="{ item.url }"
                          target="_blank"
                          referrerpolicy="no-referrer"
                          is="link-outer"
                        >
                          { item.url }
                        </a>
                      </p>
                      <div class="page_url_btn">
                        <div class="button button-secondary">
                          <a
                            href="{ routes.makePath('duplication-page', {analyticId: props.routeParams[0], targetId: item['target_id']}) }"
                            class=""
                          >
                            詳細
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--/.result-list_wrap-->
          </div>
          <!--/#result-tab01-->

          <div class="tab_contents active" if="{ state.tab == 'similarity' }">
            <div class="checkbox_wrap">
              <input
                type="checkbox"
                name="csv-check_all-similar"
                value="csv-check_all-similar"
                id="csv-check_all-similar"
                class="checkbox-input"
                onchange="{ onCheckAll }"
              />
              <label for="csv-check_all-similar" class="checkbox-parts"></label>
              <p class="history-list_check_csv-similar">
                <a
                  class="dl_csv { state.checked ? 'checked' : '' }"
                  onclick="{ onDownload }"
                >
                  選択中の解析結果をCSVでダウンロード
                </a>
              </p>
            </div>
            <!--/.checkbox_wrap-->
            <div class="sort_menu-container">
              <div
                class="button button_quaternary js-modal-open"
                data-target="modal01"
              >
                <a class="key" onclick="{ onOpenModal }">
                  解析元の特徴的な表現（キーフレーズ）
                </a>
              </div>
              <tooltip
                text="文章の「特徴的な表現（キーフレーズ）」を抽出します。<br>解析元の文章を構成するうえで重要な要素としてピックアップされたものです。"
              ></tooltip>

              <div class="sort-menu">
                <label for="sort" class="sort-menu-title">並び替え</label>
                <select
                  name="sort"
                  class="select-result"
                  onchange="{ e => onSort(e.target.value) }"
                >
                  <option value="total">総合類似度</option>
                  <option value="sentences_ratio">文章の内容</option>
                  <option value="similarity_count">類似箇所</option>
                  <option value="similarity_ratio">最高類似率</option>
                  <option value="feature_ratio">
                    特徴的な表現（キーフレーズ）
                  </option>
                </select>
              </div>
              <!--/.sort-menu-->
            </div>
            <!--/.sort_menu-container-->

            <div class="result-table-wrap">
              <table class="result-table">
                <thead class="result-heading similar">
                  <tr>
                    <th class="csv"></th>
                    <th class="total">総合類似度</th>
                    <th class="txt_content">
                      文章の内容
                      <br />
                      <span class="txt_content_sub">
                        （類似箇所/最高類似率）
                      </span>
                    </th>
                    <th class="txt_key">特徴的な表現</th>
                    <th class="page_title">ページタイトル</th>
                    <th class="page_url">URL</th>
                  </tr>
                </thead>
                <tbody class="result-contents similar">
                  <tr each="{ (item, i) in state.items }">
                    <td class="csv">
                      <div class="history-list_check-container">
                        <p class="history-list_check-similar">
                          <input
                            type="checkbox"
                            name="csv-check-similar"
                            id="csv-check-similar-{ i }"
                            class="checkbox-input"
                            checked="{ item.checked }"
                            onchange="{ e => onCheck(e, i) }"
                          />
                          <label
                            for="csv-check-similar-{ i }"
                            class="checkbox-parts history-list_check"
                          ></label>
                        </p>
                      </div>
                      <!--/.history-list_check-container-->
                    </td>
                    <td class="total">
                      <div
                        class="level-{ getLevel(item.total * 100, 'total') }"
                      >
                        <div class="gauge-graph">
                          <gauge
                            meter="{ (item.total * 100).toFixed(0) }"
                          ></gauge>
                        </div>
                        <emphasized-value
                          ratio="{ item.total }"
                          fixed="0"
                        ></emphasized-value>
                      </div>
                    </td>
                    <td class="txt_content">
                      <div
                        class="level-{ getLevel(item.sentences_ratio * 100, 'ratio') }"
                      >
                        <emphasized-value
                          ratio="{ item.sentences_ratio }"
                        ></emphasized-value>
                        <div class="txt_content_sub">
                          （{ item.similarity_count }箇所｜{
                          (item.similarity_ratio *
                          100).toFixed(item.similarity_ratio == 1 ? 0 : 1)}%）
                        </div>
                      </div>
                    </td>
                    <td class="txt_key">
                      <div
                        class="level-{ getLevel(item.feature_ratio * 100, 'ratio') }"
                      >
                        <emphasized-value
                          ratio="{ item.feature_ratio }"
                        ></emphasized-value>
                      </div>
                    </td>
                    <td class="page_title">
                      <p>{ item.title }</p>
                    </td>
                    <td class="page_url">
                      <p>
                        <a
                          href="{ item.url }"
                          target="_blank"
                          referrerpolicy="no-referrer"
                          is="link-outer"
                        >
                          { item.url }
                        </a>
                      </p>
                      <div class="page_url_btn">
                        <div class="button button-secondary">
                          <a
                            href="{ routes.makePath('similarity-page', {analyticId: props.routeParams[0], targetId: item['target_id']}) }"
                            class=""
                          >
                            詳細
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--/.result-list_wrap-->
          </div>
          <!--/#result-tab02-->
        </section>
        <!--/.result_list-wrap-->
      </div>
      <!--/.page_inner-->
    </section>
    <!--page_wrap-->
  </div>
  <!--/.wrapper-->
  <keyphrase-modal
    status="{ state.modalStatus }"
    keyphrase="{ state.keyphrase }"
    radar="{ state.radar }"
    on-close="{ onCloseModal }"
  ></keyphrase-modal>
  <form
    id="csv-form"
    action="{ state.tab == 'duplication'
        ? '/download/kagemusya/'
        : '/download/similarity/' }"
    method="POST"
  >
    <input type="hidden" name="analytic_id" value="{ props.routeParams[0] }" />
    <input type="hidden" name="ids" />
  </form>

  <script>
    import di from "dependeny-injection";
    import pager from "@tags/parts/pager.riot";
    import tooltip from "@tags/parts/tooltip.riot";
    import gauge from "@tags/parts/gauge.riot";
    import keyphraseModal from "@tags/modal/keyphrase-modal.riot";

    import { api as ResultsApi } from "@model/results.js";
    import { getLevel } from "@model/utils.js";
    import routes from "@model/routes.js";

    export default {
      components: { pager, tooltip, gauge, "keyphrase-modal": keyphraseModal},
      getLevel,
      onBeforeMount() {
        this.routes = routes;
        this.modalId = "keyphrase-modal";
        this.state = {
          checked: false,
          isShow: false,
          analytic: { status: 1 },
          tab: "duplication",
          items: [],
          analysis: {},
          keyphrase: [],
          radar: [],
          modalStatus: false,
        };
      },
      onToggleShow() {
        this.state.isShow = !this.state.isShow;
        this.update();
      },
      async onMounted(props, state) {
        const id = props.routeParams[0];
        di.loader.setState(true);
        const res = await ResultsApi.requestPages(id);
        if (res && res.success) {
          state.analytic = res.analytic;
          state.items = res.items;
          state.keyphrase = res.keyphrase;
          state.radar = [res.radar];
        } else {
          di.toast.push(
            res && res.msg ? res.msg : "エラーが発生しました。",
            "negative"
          );
        }
        di.loader.setState(false);
        this.onSort("length");
      },
      onChangeTab(name) {
        this.state.tab = name;
        this.state.checked = false;
        for (const item of this.state.items) {
          item.checked = false;
        }
        this.onSort(name == "duplication" ? "length" : "total");
      },
      onOpenModal(e) {
        this.update({ modalStatus: true });
      },
      onCloseModal(e) {
        this.update({ modalStatus: false });
      },
      onSort(column) {
        this.update({
          items: this.state.items.sort((a, b) => b[column] - a[column]),
        });
      },
      onCheck(e, i) {
        this.state.items[i].checked = e.target.checked;
        this.update({
          checked: this.state.items.reduce((a, c) => {
            return a || c.checked;
          }, false),
        });
      },
      onCheckAll(e) {
        for (const item of this.state.items) {
          item.checked = e.target.checked;
        }
        this.update({
          checked: this.state.items.reduce((a, c) => {
            return a || c.checked;
          }, false),
        });
      },
      onDownload(e) {
        if (!this.state.checked) {
          return;
        }
        this.$('input[name="ids"]').value = JSON.stringify(
          this.state.items.reduce((a, c) => {
            if (c.checked) {
              a.push(c.target_id);
            }
            return a;
          }, [])
        );
        this.$("#csv-form").submit();
      },
    };
  </script>
</items-page>
